import Location from './components/Location';
import './App.css';
import Footer from './footer/Footer';

function App() {
  return (
    <div>
      <Location /> 
      <Footer/>
    </div>
  );
}

export default App;
